<template>
    <Dialog v-model:open="open">
        <DialogContent class="sm:max-w-[925px]" @open-auto-focus.prevent>
            <DialogHeader>
                <DialogTitle>ABR lookup results</DialogTitle>
            </DialogHeader>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>Name</TableHead>
                        <TableHead>Name Type</TableHead>
                        <TableHead>Entity Name</TableHead>
                        <TableHead>Entity Type</TableHead>
                        <TableHead>Location</TableHead>
                        <TableHead>ABN</TableHead>
                        <TableHead>ACN</TableHead>
                        <TableHead>Status</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <TableRow v-for="abr in props.abr" :key="abr.abn">
                        <TableCell>{{ abr.name }}</TableCell>
                        <TableCell>{{ abr.name_type }}</TableCell>
                        <TableCell>{{ abr.entity_name }}</TableCell>
                        <TableCell>{{ abr.entity_type_name }}</TableCell>
                        <TableCell>{{ abr.address_postcode }} {{ abr.address_state }}</TableCell>
                        <TableCell>
                            <div class="flex items-center justify-between">
                                <span>{{ abr.abn }}</span>
                                <TooltipProvider :delay-duration="0">
                                    <Tooltip :open="copied && text === abr.abn ? true : undefined">
                                        <TooltipTrigger as-child>
                                            <Button
                                                variant="icon"
                                                size="icon-sm"
                                                class="cursor-pointer"
                                                @click="copyABN(abr.abn)"
                                            >
                                                <CopyIcon class="w-3 h-3" />
                                            </Button>
                                        </TooltipTrigger>
                                        <TooltipContent>
                                            <span v-if="!copied">Copy ABN</span>
                                            <span v-else>Copied!</span>
                                        </TooltipContent>
                                    </Tooltip>
                                </TooltipProvider>
                            </div>
                        </TableCell>
                        <TableCell>{{ abr.acn || '--' }}</TableCell>
                        <TableCell>{{ abr.abn_status }}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@/components/ui/table'
import { ref } from 'vue'
import { useClipboard } from '@vueuse/core'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { CopyIcon } from '@radix-icons/vue'

type Abr = {
    name: string
    name_type: string
    entity_name: string
    entity_type_name: string
    address_postcode: string
    address_state: string
    abn: string
    acn: string
    abn_status: string
}

const props = defineProps<{
    abr: Abr[]
}>()

const open = defineModel()

const { copy, copied, text } = useClipboard()

const copyABN = async (abn: string) => {
    await copy(abn)
}
</script>
